import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=134715a6&scoped=true"
import script from "./layout?vue&type=script&lang=js&external"
export * from "./layout?vue&type=script&lang=js&external"
import style0 from "./layout.vue?vue&type=style&index=0&id=134715a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134715a6",
  null
  
)

export default component.exports